// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:21:07

export default {
  "id": "water-dig-rescue",
  "slug": "water-dig-rescue",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/4e840a9a7b45449d8655dbbc86b42bf3-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/4e840a9a7b45449d8655dbbc86b42bf3/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Water Dig Rescue",
      "description": "Dive into the captivating world of \"Water Dig Rescue,\" a physics-based puzzle game where strategy and water manipulation go hand-in-hand. Players carve their way through sand to guide streams of water, aiming to fill a waiting truck at each level's end. With a touch of ingenuity and the laws of physics, can you solve the puzzles and achieve a triumphant splash?",
      "instructions": "Objective: Your goal is to collect enough water in the destination truck to win the level.\nInteract: Click and drag on the sand to dig a path for the water to flow.\nCollect: Guide the water to collect golden balls for extra points.\nSolve: Navigate through a variety of obstacles and utilize the environment to lead water to the truck.\nAdvance: Complete the level to move onto the next, with each stage increasing in complexity.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "water"
      ]
    },
    "zh-CN": {
      "title": "水域挖掘救援",
      "description": "深入迷人的“水挖救援”世界，这是一款基于物理学的解谜游戏，策略与水操控相辅相成。玩家在沙地中雕刻路径，引导水流，旨在在每个关卡结束时将水流引入等待的卡车。运用一点巧思和物理定律，你能否解决谜题，取得胜利的泼水狂欢？",
      "instructions": "目标：你的目标是收集足够的水到目的地卡车中，以赢得关卡。\n交互：点击并拖动沙地，为水流挖出一条通道。\n收集：引导水流收集金色球体，获得额外积分。\n解决：穿越各种障碍，利用环境引导水流到卡车。\n前进：完成关卡，进入下一关，每个阶段难度都会增加。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "水"
      ]
    },
    "zh-TW": {
      "title": "水钻救援",
      "description": "深入迷人的「水挖救援」世界，一款基於物理的謎題遊戲，策略與水操控相輔相成。玩家透過雕刻沙地引導水流，目標是在每關結束時填滿等待的卡車。只需一點創意和物理法則，你能否解開謎題，達成獲勝的噴射效果？",
      "instructions": "目標：您的目標是在目標卡車中收集足夠的水來贏得關卡。\n互動：點擊並拖動沙子來挖掘一條水流的道路。\n收集：引導水流向收集金色球來獲得額外分數。\n解決：通過各種障礙，並利用環境將水引導到卡車。\n進階：完成關卡以進入下一關，每個階段複雜性都會增加。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "水"
      ]
    },
    "zh-HK": {
      "title": "水挖救援",
      "description": "投入引人入勝的「水挖救援」世界，一款基於物理的謎題遊戲，策略與水操控並重。玩家在沙中開路，引導水流，目標是於每關結束時將水填滿等待的卡車。運用一絲巧思和物理定律，你能解開謎題，達成勝利的噴灑嗎？",
      "instructions": "目標：你的目標是收集足夠的水到達目標卡車以贏得關卡。\n互動：點擊並拖動沙地來挖出水流的道路。\n收集：引導水流收集金色球以獲得額外分數。\n解謎：穿越各種障礙並利用環境將水流引導到卡車。\n進階：完成關卡以進入下一關，每個階段都會增加複雜性。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人玩家",
        "水"
      ]
    },
    "ja": {
      "title": "ウォーターダグレスキュー",
      "description": "“ウォーターダグレスキュー”の魅力的な世界に飛び込み、物理に基づくパズルゲームで、戦略と水の操作が一体となっています。プレイヤーは砂を切り開き、水の流れを導き、各レベルの終わりに待つトラックを満たすことを目指します。独創的なアイデアと物理法則を駆使して、パズルを解き、華麗なスプラッシュを達成できるでしょうか？",
      "instructions": "目標: 目的地のトラックに十分な水を集めることでレベルをクリアする。\n操作: クリックしてドラッグして砂に道を作り、水が流れるようにする。\n収集: 水を導いて金色のボールを集め、ボーナスポイントを獲得する。\n解決: 多様な障害を通過し、環境を利用して水をトラックに導く。\n進行: レベルをクリアして次のステージに進む。各ステージは複雑さが増していく。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "水"
      ]
    },
    "ko": {
      "title": "물고개 구조 작전",
      "description": "\"물 파괴 구조\"의 매력적인 세계로 뛰어들어보세요. 전략과 물 조작이 함께하는 물리 기반 패uzzle 게임입니다. 플레이어들은 모래를 파고서 물줄기를 이끌어내고, 각 레벨의 마지막에 기다리는 트럭을 채우려고 합니다. 발명성과 물리법칙을 조합하면, 퍼즐을 해결하고 성공적인 스파쉬를 달성할 수 있을까요?",
      "instructions": "목표: 목적지 트럭에 충분한 물을 모으는 것이 목표입니다.\n인터랙션: 모래 위를 클릭하고 드래그하여 물이 흐를 길을 파내세요.\n수집: 물을金色의 공으로 이동시켜 추가 점수를 받으세요.\n해결: 다양한 장애물을 통과하고 환경을 활용하여 물을 트럭으로 이동시켜주세요.\n진행: 레벨을 완료하여 다음 단계로 이동하세요. 각 단계는 복잡성을 증가시킵니다.",
      "genres": [
        "캐주얼",
        "파uzzle"
      ],
      "tags": [
        "1플레이어",
        "물"
      ]
    },
    "fr": {
      "title": "Sauvetage de la digue d'eau",
      "description": "Plongez dans le monde captivant de \"Water Dig Rescue\", un jeu de puzzle basé sur la physique où la stratégie et la manipulation de l'eau sont inextricablement liées. Les joueurs creusent leur chemin à travers le sable pour guider des flux d'eau, visant à remplir un camion en attente à la fin de chaque niveau. Avec un soupçon d'ingéniosité et les lois de la physique, pouvez-vous résoudre les puzzles et atteindre un splash triomphal ?",
      "instructions": "Objectif : Votre objectif est de recueillir suffisamment d'eau dans le camion de destination pour gagner le niveau.\nInteragir : Cliquez et faites glisser sur le sable pour creuser un chemin pour que l'eau coule.\nCollecter : Guidez l'eau pour collecter des boules dorées pour des points supplémentaires.\nRésoudre : Navigatez à travers une variété d'obstacles et utilisez l'environnement pour guider l'eau vers le camion.\nAvancer : Terminez le niveau pour passer au suivant, chaque étape augmentant en complexité.",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "eau"
      ]
    }
  }
};
